/* eslint-disable max-len */
import React, {Component} from 'react';
import {autobind} from 'core-decorators';
import {graphql} from 'react-apollo';
import Popup from 'components/popup';
import userQuery from 'graphql/queries/user.gql';
import SectionTitle from 'components/section-title';
import Navigation from './navigation';
import styles from './styles.css';

const getStorageKey = userId => `redin.tutorial.${userId}`;

@graphql(userQuery)
@autobind
export default class SessionOrganizationTutorial extends Component {
    state = {
        step: 0,
        visible: true,
    };

    handleOnChange(step) {
        this.setState({step});
    }

    handleClose() {
        window.localStorage.setItem(getStorageKey(this.props.data.user.id), true);
        this.setState({visible: false});
    }

    renderStep(index) {
        const steps = [
            (
                <div className={styles.content}>
                    <div className={styles.logo} />
                    <p>A partir de ahora podés ver y utilizar el portal como cualquiera de tus multiplicadores.</p>
                    <p>
                        Ellos ya no tienen más acceso al sitio y sos vos el encargado de realizar los pedidos
                        en su nombre.
                    </p>
                    <p>Repasemos cómo hacés para ver y usar el portal como uno de tus multiplicadores:</p>
                </div>
            ),
            (
                <div className={styles.content}>
                    <div className={styles.title}>
                        <SectionTitle title='Instructivo de uso' />
                    </div>
                    <p>
                        <strong>En el margen superior derecho encontrarás un desplegable</strong> que te permite
                        seleccionar la organización como la que querés ver y usar el sitio.
                    </p>
                    <p>
                        Vas a poder seleccionar uno a la vez y realizar todas las acciones permitidas para un
                        multiplicador.
                    </p>
                    <div className={styles.header} />
                    <p>
                        Una vez seleccionado uno de tus multiplicadores podrás hacer todos los pedidos que quieras
                        en su nombre.
                    </p>
                    <p>
                        Al hacerlo, te llegará un mail confirmando tu acción.
                    </p>
                    <p>
                        <strong>Te pedimos que se lo reenvíes para que él esté al tanto de lo que realizaste.</strong>
                    </p>
                </div>
            ),
            (
                <div className={styles.content}>
                    <div className={styles.title}>
                        <SectionTitle title='Instructivo de uso' />
                    </div>
                    <div className={styles.menu} />
                    <p>
                        Podrás siempre ver el <strong>historial de pedidos</strong> realizados accediendo desde
                        el menú del portal.
                    </p>
                    <p>
                        Mientras tengas seleccionada en la home tu organización Nidera Comercial, en el historial
                        vas a ver de manera consolidada lo pedido para tus multiplicadores.
                    </p>
                    <p>
                        Si accedés a <strong>historial de pedidos</strong> como un multiplicador especifico,
                        sólo verás lo referente a ese multiplicador.
                    </p>
                </div>
            ),
        ];
        return steps[index];
    }

    render() {
        const {user} = this.props.data;
        const shouldRender = (
            user
            && this.state.visible
            && !window.localStorage.getItem(getStorageKey(user.id))
        );

        if (!shouldRender) return null;

        return (
            <Popup visible={shouldRender}>
                <div className={styles.root}>
                    <button onClick={this.handleClose} theme='white'>
                        <i className='material-icons'>close</i>
                    </button>
                    {this.renderStep(this.state.step)}
                    <Navigation
                        steps={3}
                        activeStep={this.state.step}
                        onChange={this.handleOnChange}
                        onClose={this.handleClose}
                    />
                </div>
            </Popup>
        );
    }
}



// WEBPACK FOOTER //
// ./components/session-organization-tutorial/index.js